export const FileWrapper: React.FC = ({ children }) => (
  <div className="file mt-5">
    {children}
  </div>
)